var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowflake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17",
    width: 16,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.392 4.25a.857.857 0 0 0 1.212 0l2.286-2.285A.857.857 0 0 0 9.678.753L8.204 2.228a.286.286 0 0 1-.412 0L6.318.753a.857.857 0 0 0-1.211 1.212L7.392 4.25ZM3.747 7.896 1.46 5.611A.857.857 0 0 0 .25 6.822l1.474 1.474a.285.285 0 0 1 0 .412L.25 10.182a.857.857 0 0 0 1.211 1.211l2.286-2.285a.857.857 0 0 0 0-1.212ZM8.604 12.754a.857.857 0 0 0-1.212 0l-2.285 2.285a.857.857 0 0 0 1.211 1.212l1.474-1.475a.285.285 0 0 1 .412 0l1.474 1.475a.857.857 0 0 0 1.211-1.212l-2.285-2.285ZM14.444 8.685a.274.274 0 0 1 0-.366l1.337-1.543a.86.86 0 0 0-1.28-1.142l-2 2.285a.834.834 0 0 0 0 1.143l2 2.286a.857.857 0 1 0 1.28-1.143l-1.337-1.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.415 8.708a.285.285 0 0 1 0-.412l2.903-2.903a.858.858 0 1 0-1.211-1.211L8.204 7.085a.286.286 0 0 1-.412 0L4.89 4.182a.857.857 0 1 0-1.212 1.211l2.903 2.903a.286.286 0 0 1 0 .412L3.678 11.61a.857.857 0 0 0 1.212 1.211l2.902-2.903a.286.286 0 0 1 .412 0l2.903 2.903a.857.857 0 0 0 1.211-1.211L9.415 8.708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/snowflake.3ed85ecc3288276f4d53ba95731982b9.svg";
export { ForwardRef as ReactComponent };